import { useConnect } from '@lore/query-connect';
import useTags from './useTags';
import _ from 'lodash';

export default function useStoryTags(story, type) {
  const tags = useTags();

  const tagNodes = useConnect('tagNode.find', {
    where: {
      eager: {
        $where: {
          tag: {
            $where: {
              type: type
            }
          },
          storyId: story.id
        }
      }
    },
    pagination: {
      pageSize: 1000
    }
  }, {
    enabled: !!story.id && _.isInteger(story.id)
  });

  return {
    state: tagNodes.state,
    data: tagNodes.data.map(function(tagNode) {
      const tag = _.find(tags.data, tag => tag.id === tagNode.data.tagId);

      return {
        id: tagNode.id,
        cid: tagNode.cid,
        data: tag.data,
        _tag: tag,
        _tagNode: tagNode,
        _meta: 'generated in useStoryTags',
      }
    })
  }
}
